import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "../lib/api";

export default function DevBadge() {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    api.get("/environment").then(({ data }) => setEnv(data)).catch(() => setEnv(null));
  }, []);

  if (!env?.is_dev) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-1.5 text-[11px] font-semibold tracking-wider"
      style={{ background: "#FF9E1B", color: "#2B1A00", borderTop: "2px solid #2B1A00" }}
      data-testid="dev-environment-badge"
    >
      <span className="flex items-center gap-1.5 uppercase">
        <AlertTriangle size={13} /> {env.label || "DEV"} environment — not live client data
      </span>
      {env.email_redirect && (
        <span className="opacity-80" data-testid="dev-email-redirect-note">
          All outbound email goes to {env.email_redirect}
        </span>
      )}
    </div>
  );
}
